// extracted by mini-css-extract-plugin
export default {"root":"MaskTab_root__3BFWX","selected":"MaskTab_selected__fayxt","error":"MaskTab_error__3AwiQ","badge":"MaskTab_badge__6u4LC","tabWrapper":"MaskTab_tabWrapper__hpjwL"};